module.exports = __webpack_public_path__ + "img/11.46631575.jpg";